'use strict';
/**
 * @author Maxim Seredkin
 */

export default function() {
    return {
        restrict: 'A',
        template: require('../view/project-tab-readiness.html'),
        scope: {
            projectReadiness: '=myModel',
            edit: '=edit',
        },
        controller: ['$scope', '$routeParams',
                     function($scope, $routeParams) {

                     }],
    };
}
